// Module
var code = "<div> <van-cell :value=\"`已发送验证码至${userInfo.email}`\"/> <van-field v-model=\"code\" label=\"验证码\" placeholder=\"请输入验证码\"/> <div class=\"footer\"> <van-button type=\"info\" size=\"large\" @click=\"loginAndRegist\">注册并登录</van-button> </div> </div> ";
// Exports
module.exports = code;